import styled, { css } from 'styled-components';
import { IconButton } from '@mui/material';

import { ReactComponent as EditIconSvg } from '../../../../assets/icons/v2/edit-blue.svg';
import { ReactComponent as SaveIconSvg } from '../../../../assets/icons/v2/save.svg';
import { ReactComponent as ArchiveIconSvg } from '../../../../assets/icons/v2/archive.svg';
import { ReactComponent as TrashIconSvg } from '../../../../assets/icons/v2/trash.svg';
import Button from '../../../../chat/components/Button';
import colors from '../../../../styles/colors';

const MenuCell = styled.div`
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
`;

const MenuIconButton = styled(IconButton)`
  padding: 4px;
`;

const RenameDoneButton = styled(Button)`
  flex-shrink: 0;
  padding: 3px 12px;
  font-size: 12px;
  border-radius: 5px;
`;

const iconStyle = css`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  flex-shrink: 0;
`;

const EditIcon = styled(EditIconSvg)`
  ${iconStyle}
`;

const SaveIcon = styled(SaveIconSvg)`
  ${iconStyle}
`;

const ArchiveIcon = styled(ArchiveIconSvg)`
  ${iconStyle}
`;

const TrashIcon = styled(TrashIconSvg)`
  path {
    fill: none;
    stroke: ${colors.base.danger};
  }
  ${iconStyle}
`;

const DeleteText = styled.span`
  color: ${colors.base.danger};
`;

export {
  MenuCell,
  MenuIconButton,
  RenameDoneButton,
  EditIcon,
  SaveIcon,
  ArchiveIcon,
  TrashIcon,
  DeleteText,
};
